'use strict';
import {LoadingIconDirective, LoadingIconController} from './LoadingIconDirective';
const angular = require('angular');

module.exports = angular
  .module('app.components.loading-icon', [])
  .constant('LOADING_STATE', require('./LOADING_STATES.js'))
  .directive('loadingIcon', LoadingIconDirective)
  .controller('LoadingIconController', LoadingIconController);



// WEBPACK FOOTER //
// ./src/js/core-components/loading-icon/index.js